import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fields", "destroyField", "toggle"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const checked = this.toggleTarget.checked
    this.fieldsTarget.classList.toggle("hidden", !checked)
    this.destroyFieldTarget.value = checked ? "0" : "1"

    const hints = document.querySelector('[id$="doclift_template_input"] .inline-hints')
    if (hints) hints.classList.toggle("hidden", !checked)
  }
}
